import React  from 'react';
import Stepper from '@mui/material/Stepper';
import { styled } from '@mui/styles';

const StepperCustomizable = styled((props) => <Stepper {...props} />)
  (({ theme, color }) => ({
    '& .MuiStepLabel-label.Mui-active': {
      color: color,
      fontWeight: 700
    },
    '& .MuiStepIcon-root.Mui-active': {
      color: theme.palette.secondary.main,
      fontWeight: 700
    },
    '& .MuiStepLabel-label': {
      color: '#9CA3AF'
    },
    '& .MuiSvgIcon-root-MuiStepIcon-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiStepLabel-label.Mui-completed': {
      color: color,
      fontWeight: 700
    },
    '& .MuiStepIcon-root.Mui-completed': {
      color: theme.palette.secondary.main,
      fontWeight: 700
    },
    '& .MuiStepConnector-line': {
      display: 'block',
      borderColor: '#f3f6f83b',
      borderStyle: 'solid',
      borderWidth: '0.1pt'
    }
  }))

const StepperCustom = (props) => {
  return (
    <StepperCustomizable {...props} />
  )
}

export default StepperCustom
